module.exports = __webpack_public_path__ + "img/cocina-dominicana.c0f5879a.png";